import { render, staticRenderFns } from "./Ratingstraight.vue?vue&type=template&id=6e965b76&scoped=true&"
import script from "./Ratingstraight.vue?vue&type=script&lang=js&"
export * from "./Ratingstraight.vue?vue&type=script&lang=js&"
import style0 from "./Ratingstraight.vue?vue&type=style&index=0&id=6e965b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e965b76",
  null
  
)

export default component.exports